import firebase from 'firebase/app';
import 'firebase/auth';

export const AuthenticationService = () => {
    firebase.auth().onAuthStateChanged((user) => {
        if (user) {
            // User is signed in.
            localStorage.setItem('logged_in', true);
        } else {
            // User is not signed in.
            localStorage.setItem('logged_in', false);
        }
    });
};



